<div style="clear: both; height: 10px; display: block;"></div>
<p class="resultsHeading">
    <span [innerHTML]="heading"></span>
</p>
